import Image from '@/common/components/Image/Image'
import { MarketplaceAffiliation } from '@/queries/marketplace/schema'
import { useTranslation } from 'react-i18next'

type AffiliationCardProps = {
  affiliation: MarketplaceAffiliation
  onClick: (affiliation: MarketplaceAffiliation) => void
}

export default function AffiliationCard({
  affiliation,
  onClick,
}: AffiliationCardProps) {
  const { t } = useTranslation()

  const itemLabel =
    affiliation.number_of_items_in_affiliation === 1 ? t('item') : t('items')

  return (
    <button
      type="button"
      onClick={() => onClick(affiliation)}
      className="border rounded-lg shadow-lg p-6 flex flex-col items-center text-center hover:shadow-xl transition-shadow duration-300"
    >
      <div className="mb-4">
        {affiliation.logo ? (
          <Image
            className="object-contain size-20 border"
            path={affiliation.logo}
          />
        ) : (
          <div className="size-20 bg-gray-200 flex items-center justify-center text-sm text-gray-500 border">
            {t('no_image')}
          </div>
        )}
      </div>

      <div className="font-semibold text-gray-800 text-base mb-4">
        {affiliation.name}
      </div>

      <div className="text-sm text-gray-600 font-medium border-t pt-2 w-full">
        {affiliation.number_of_items_in_affiliation} {itemLabel}
      </div>
    </button>
  )
}
